<template>
  <div>
    <el-container class="layout-container" :class="{ 'service-layout': serviceThemeActive }">
      <el-main>
        <router-view :key="routeViewKey" />
      </el-main>
    </el-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'LayoutWithoutMenu',
  computed: {
    ...mapGetters('template', ['serviceThemeEnabled']),
    isServiceSection() { return this.$route.matched.some(record => record.meta.section === 'service') },
    serviceThemeActive() { return this.isServiceSection && this.serviceThemeEnabled },
    routeViewKey() {
      // 服务平台公共布局保持同一实例，内部页面仍由其自己的 router-view 更新。
      return this.$route.matched.some(record => record.path === '/service') ? 'service' : this.$route.fullPath
    }
  },
}
</script>

<style lang="scss" scoped>
.layout-container {
  width: 100%;
  margin: auto;
  height: 100%;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    background-image: url('@/static/images/service-icon/serviceBack.png');
  .el-main {
    padding: 0;
    overflow: hidden;
  }
}
.layout-container.service-layout {
  // 服务平台背景由 App 的公共内容容器统一绘制，包含上方位置导航。
  background: transparent;
}
</style>
